import styled from 'styled-components';

export const Chips = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Chip = styled.span`
  display: flex;
  flex: none;
  gap: 6px;
  align-items: center;
  max-width: 100%;
  height: 28px;
  padding: 0 8px;
  overflow: hidden;
  font-size: 12px;
  color: #262626;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 2px;

  &[data-highlighted='true'] {
    color: #d16d0f;
    background: rgba(247, 142, 30, 0.12);
    border-color: #f78e1e;
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  margin-right: -4px;
  font-size: 10px;
  color: #8c8c8c;
  cursor: pointer;
  background: none;
  border: none;
`;
